import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Bell = function Bell(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.984 19.77c-1.2804 0.073913-2.6961 0.073913-3.9765 0-0.15652-0.0086957-0.29174 0.059565-0.3787 0.18087-0.086957 0.12087-0.10565 0.27826-0.049565 0.41652 0.40087 0.9913 1.3496 1.6322 2.4165 1.6322 1.067 0 2.0152-0.64087 2.4161-1.6322 0.056087-0.13826 0.037391-0.29565-0.049565-0.41652-0.086522-0.1213-0.22348-0.19043-0.37826-0.18087m5.8378-3.4226c0 2.27-4.9035 2.6087-7.8261 2.6087-2.923 0-7.8261-0.3387-7.8261-2.6087 0-0.77739 0.47-1.28 0.96739-1.8122 0.87652-0.93652 2.0761-2.2191 2.0761-6.0139 0-1.9887 1.243-3.763 3.0743-4.4635-0.02087-0.10522-0.03087-0.21174-0.03087-0.31913 0-0.95913 0.78-1.7391 1.7391-1.7391 0.95913 0 1.7391 0.78 1.7391 1.7391 0 0.10739-0.010435 0.21391-0.031304 0.31913 1.8313 0.70043 3.0748 2.4748 3.0748 4.4635 0 3.7948 1.1996 5.0774 2.0757 6.0139 0.49783 0.53217 0.96783 1.0348 0.96783 1.8122",
    fillRule: "nonzero"
  })));
};

Bell.displayName = 'Bell';
export default Bell;